import * as Sentry from '@sentry/browser';

export function error(err: Error, msg?: string) {
  if (msg) {
    console.error(msg);
    Sentry.captureMessage(msg);
  }
  console.error(err);
  Sentry.captureException(err);
}
